import { useEffect } from "react";

type Key = string | boolean | number | null;

export function useScrollToTop(...keys: Key[]) {
  const key = JSON.stringify(keys);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);
}
